import { styled } from '@mui/material';
import { DataGridPro, gridClasses } from '@mui/x-data-grid-pro';
import { WidgetContent } from '@procureai/ui-mui';

export const DataGridProStyled = styled(DataGridPro)(({ theme }) => ({
  [`&.${gridClasses.root}`]: {
    borderWidth: 0,
    '--DataGrid-rowBorderColor': 'none',
  },
  [`& .${gridClasses.columnHeaderTitle}, & .${gridClasses.columnHeaderTitleContainer}`]: {
    ...theme.typography.subtitle2,
  },
  [`& .${gridClasses.columnHeaderTitleContainerContent}`]: {
    ...theme.typography.subtitle2,
    lineHeight: 1.2,
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  [`& .${gridClasses.columnHeader}:focus-within, & .${gridClasses.cell}:focus-within`]: {
    outline: 'none',
  },
  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.cell}:focus`]: {
    outline: 'none',
  },

  [`& .${gridClasses.cell}, & .${gridClasses.columnHeader}`]: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 30,
    paddingRight: 30,
    borderRight: `1px solid ${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'}`,
  },
  [`& .${gridClasses.columnSeparator}`]: {
    display: 'none',
  },
  [`& .${gridClasses.pinnedRows}`]: {
    '--DataGrid-rowBorderColor': `${theme.palette.mode === 'light' ? '#f0f0f0' : '#303030'}`,
  },
})) as typeof DataGridPro;

export const WidgetContentStyled = styled(WidgetContent)({
  display: 'flex',
  flexDirection: 'column',
  flex: '1 1 0',
  overflow: 'hidden',
});
